import {
    GET_ASSET_NUMBER_VALUE,
    SET_ASSET_NUMBER_VALUE,
    GET_TRANSFER_ASSET_DETAILS,
    SET_TRANSFER_ASSET_DETAILS,
    SET_ASSET_ERROR,
    GET_REACTIVATION_ASSET_DETAILS,
    SET_REACTIVATION_ASSET_DETAILS,
    GET_FLEET_ASSET_VALIDATION,
    SET_FLEET_ASSET_VALIDATION,
    SET_FLEET_Item_Id
} from "./AssetNumberType"

const getAssetNumberValue = (val : any) => ({
    type: GET_ASSET_NUMBER_VALUE,
    val
});

const setAssetNumberValue = (assetNumberValue: any) => ({
    type: SET_ASSET_NUMBER_VALUE,
    assetNumberValue: assetNumberValue
});

const getTransferAssetDetails = (assetNumber : any, transDispoReactivationAssetDetailId: any) => ({
    type: GET_TRANSFER_ASSET_DETAILS,
    assetNumber,
    transDispoReactivationAssetDetailId
});

const setTransferAssetDetails = (assetDetail : any) => ({
    type: SET_TRANSFER_ASSET_DETAILS,
    assetDetail
});

const setAssetError = (error : any) => ({
    type: SET_ASSET_ERROR,
    error
});

const getReactivationAssetDetails = (assetNumber : any) => ({
    type: GET_REACTIVATION_ASSET_DETAILS,
    assetNumber
});

const setReactivationAssetDetails = (assetDetail : any) => ({
    type: SET_REACTIVATION_ASSET_DETAILS,
    assetDetail
});

const getFleetAssetValidation = (assetNumber : any) => ({
    type: GET_FLEET_ASSET_VALIDATION,
    assetNumber
});

const setFleetAssetValidation = (assetValidation : any) => ({
    type: SET_FLEET_ASSET_VALIDATION,
    assetValidation
});

const setFleetItemId = (itemId : any) => ({
    type: SET_FLEET_Item_Id,
    itemId
});

export {
    getAssetNumberValue,
    setAssetNumberValue,
    getTransferAssetDetails,
    setTransferAssetDetails,
    setAssetError,
    getReactivationAssetDetails,
    setReactivationAssetDetails,
    getFleetAssetValidation,
    setFleetAssetValidation,
    setFleetItemId
}
